export default {
  ENDED: "ended",
  FULLSCREEN_CHANGE: "fullscreenchange",
  PAUSE: "pause",
  PLAY: "play",
  TIME_UPDATE: "timeupdate",
  ANY: "any"
}
